/**
 * index.js - Комбинирование всех редьюсеров приложения в один объект
 * @module reducers/index
 * */

import {combineReducers} from 'redux'
import currentUsers from './currentUsers'
import topArticles from './topArticles'
import usersTimeline from './usersTimeline'
import topReferers from './topReferers'
import urlTopNextPages from './urlTopNextPages'
import pageInfo from './pageInfo'
import devices from './devices'

export default combineReducers({
    currentUsers,
    topArticles,
    usersTimeline,
    topReferers,
    pageInfo,
    devices,
    urlTopNextPages,
})



// WEBPACK FOOTER //
// ./src/reducers/index.js